import React, { Component } from 'react';
import { Grid, Header, Button } from 'semantic-ui-react';
import { withAlert } from 'react-alert';
import { compose } from 'redux';
import Loading from '../../components/Loading';
import GeneralHelper from '../../helpers/general';

class CallbackJrUpgPage extends Component {
	componentDidMount() {
		const query = GeneralHelper.queryStringToObject(this.props.location.search);

		if (query.id) {
			this.props.getTicketTransactionById(query.id);
		}
	}

	componentDidUpdate(prevProps) {
		const { meta: prevMeta } = prevProps.callbackJrUpgPageProps;
		const { meta } = this.props.callbackJrUpgPageProps;

		if (meta && meta !== prevMeta) {
			if (meta.code !== 200) {
				this.props.history.push('/payment/failure');
			}

			const alertOptions = {
				type: meta.code === 200 ? 'success' : 'error',
				...(meta.code === 40399 && { timeout: 0 })
			};
			this.props.alert.show(meta.message, alertOptions);
			this.props.resetMeta();
		}
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	render() {
		const query = GeneralHelper.queryStringToObject(this.props.location.search);

		if (!query.id) {
			return (
				<Grid centered>
					<Grid.Column>
						<Header
							as="h1"
							textAlign="center"
						>
							Cannot Process Payment
						</Header>
						<center>
							<p>Transaction ID missing.</p>
							<Button
								primary
								type="sumbit"
								onClick={
									() => this.props.history.push('/welcome')
								}
							>
								BACK TO HOME
							</Button>
						</center>
					</Grid.Column>
				</Grid>
			);
		}

		return (
			<Grid centered>
				<Grid.Column>
					<Header
						as="h1"
						textAlign="center"
					>
						Payment Processing
					</Header>
					<Loading />
				</Grid.Column>
			</Grid>
		);
	}
}

export default compose(
	withAlert()
)(CallbackJrUpgPage);
